import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Spinner from "react-spinner-material";
import NipWrapper2 from "../../Nip/NipWrapper2";
import ReapplySection from "../../Certification/ReapplySection";
import { connect } from "react-redux";
import { getAllNipApplications } from "../../../redux/Actions/NipOnboardingActions";
import { TrailThread } from "./TrailThread";
import Storage from "../../../utils/storage";
import Empty from "../../../assets/assets/empty.svg";
import Button from "../../Button/Button";
import { useHistory } from "react-router-dom";
import { getStorageItem } from "../../UserNav/getStorageItem";

const ApplicationsHome = (props) => {
  const { isGetting, getSuccess, getApplications, applications } = props;

  useEffect(() => {
    getApplications();
  },
   // eslint-disable-next-line
  [getApplications]);

  const [state] = useState({
    kit: true,
    selectType: false,
    docUpload: false,
    permitForm: false,
    shareKeys: false,
    runTest: false,
  });

  const res = (str) => {
    let newStr = str.split("_").join(" ");
    return newStr;
  };

  let { type } = getStorageItem();

  const history = useHistory();

  const kitDownload = Storage.get("kit-download");
  const selectIntType = Storage.get("select-type");
  const kitDownloadStatus = (trail) =>
    trail ? trail.downloaded_kit : kitDownload;
  const selectIntTypeStatus = (trail) =>
    trail ? trail.selected_integration_type : selectIntType;
  const uploadStartStatus = Storage.get("upload-start");
  const uploadFinishStatus = (trail) =>
    !trail ? false : trail.document_upload;
  const requestManager = (trail) => trail && trail.network_manager_request;
  const ipFormStatus = (trail) => trail && trail.ip_form_submission;
  const publicKeyStatus = (trail) => trail && trail.shared_public_key;
  const runTestStatus = (trail) => trail && trail.run_test;
  const scheduleMigrationStatus = (trail) => trail && trail.schedule_migration;
  const docApproval = (trail) => trail && trail.nip_document_approval;
  const ipPermitApproval = (trail) => trail && trail.ip_permit_approval;
  const testApproval = (trail) => trail && trail.test_approval;
  const migrationApproval = (trail) => trail && trail.migration_approval;

  const goToSingle = (id) => {
    history.push({
      pathname: `/nip/integration/${id}`,
      state: {
        id: id,
      },
    });
  };

  return (
    <NipWrapper2 currentRoute="/nip/integration/onboarding">
      <ReapplySection
        href={"/nip/integration/onboarding"}
        disabled={type === "company_network_manager"}
        type={"NIP Integration"}
        application={applications}
        title={"Easy Application for NIP Integration"}
      />

      <br />
      <br />

      <div className="nip-int-wrap">
        <div className="nip-integration-header">My Applications</div>
        {isGetting ? (
          <div className="nip-loading">
            <div className="center-spinner">
              <Spinner
                size={120}
                color={"#047558"}
                spinnerwidth={5}
                visible={true}
              />
            </div>
          </div>
        ) : getSuccess ? (
          applications && applications.length > 0 ? (
            <div className="all-nip-apps-grp">
              {applications &&
                applications.map((trail, index) => (
                  <div className="all-nip-apps" key={index}>
                    <div className="all-nip-apps-header">
                      <div className="all-nip-apps-header-top">
                        <div
                          className={
                            trail.application_type ===
                              "inward_outward_integration"
                              ? "all-nip-apps-header-title2"
                              : "all-nip-apps-header-title"
                          }
                        >
                          {trail.application_type ===
                            "inward_outward_integration"
                            ? "Inward and Outward Integration"
                            : res(trail.application_type)}
                        </div>
                        <div className="all-nip-apps-header-view">
                          <Button
                            type="button"
                            width="150px"
                            height="45px"
                            word={"View"}
                            onClick={() => goToSingle(trail.application_id)}
                          />
                        </div>
                      </div>
                      <div className="all-nip-apps-header-subtitle">
                        Get access to your{" "}
                        <span className={trail.application_type ===
                          "inward_outward_integration"
                          ? ""
                          : "span1"}>
                          {trail.application_type ===
                            "inward_outward_integration"
                            ? "Inward and Outward Integration"
                            : res(trail.application_type)}
                        </span>{" "}
                        Application
                      </div>
                    </div>

                    <div className="all-nip-apps-trail">
                      {TrailThread(
                        state,
                        kitDownloadStatus(trail && trail.nip_trail),
                        trail,
                        selectIntTypeStatus(trail && trail.nip_trail),
                        uploadStartStatus,
                        uploadFinishStatus(trail && trail.nip_trail),
                        ipFormStatus(trail && trail.nip_trail),
                        publicKeyStatus(trail && trail.nip_trail),
                        runTestStatus(trail && trail.nip_trail),
                        scheduleMigrationStatus(trail && trail.nip_trail),
                        docApproval(trail && trail.nip_trail),
                        ipPermitApproval(trail && trail.nip_trail),
                        testApproval(trail && trail.nip_trail),
                        migrationApproval(trail && trail.nip_trail),
                        requestManager(trail && trail.nip_trail)
                      )}
                    </div>
                  </div>
                ))}
            </div>
          ) : (
              <div className="all-nip-apps-empty">
                <div className="empty-dashboard">
                  <div className="empty2">
                    <div>
                      <img src={Empty} alt="empty2" />
                    </div>
                    <h1>No Application</h1>
                    <p>
                      There’s no application started. Please click on the “Apply
                    Now” button above <br /> to begin your NIP Integration
                    Application.
                  </p>
                  </div>
                </div>
              </div>
            )
        ) : (
              <div className="nip-error">Error fetching applications</div>
            )}
      </div>
    </NipWrapper2>
  );
};

ApplicationsHome.propTypes = {
  applications: PropTypes.any,
  getApplications: PropTypes.func,
  getSuccess: PropTypes.any,
  isGetting: PropTypes.any,
  managerId: PropTypes.any,
};
const mapStateToProps = (state) => {
  return {
    isGetting: state.nipOnboarding.isGettingAllNipApplications,
    getSuccess: state.nipOnboarding.getNipApplicationsSuccess,
    applications:
      state.nipOnboarding.nipApplications &&
      state.nipOnboarding.nipApplications.data,
    managerId:
      state.nipOnboarding.nipApplications &&
      state.nipOnboarding.nipApplications.network_manager_id,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getApplications: () => dispatch(getAllNipApplications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationsHome);
